import React from "react";
import Modal from "./Modal/Modal";
import logger from "../logger";
import { APPLICATION_ID } from "../utilities";
import { StateContext } from "../state/State";
class ErrorBoundary extends React.Component {
  static contextType = StateContext;
  constructor(props) {
    super(props);
    this.state = { open: false, error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
      open: true,
    });
    logger.error({
      message: error,
      module: "Formserver",
      fileName: "ErrorBoundary.js",
      functionName: "componentDidCatch",
      logLevel: "Critical",
      details: errorInfo,
      parameters: null,
      url: window.location.href,
      application: APPLICATION_ID, //TODO: for formserver we need application id
    });
  }

  componentDidUpdate(_, prevState) {
    const [state] = this.context;
    const { error: errorFS } = state || {};
    if (errorFS) {
      const { error, errorInfo } = errorFS || {};
      if (error && errorInfo && prevState.error !== error) {
        this.setState({
          error,
          errorInfo,
          open: true,
        });
      }
    }
  }

  render() {
    return (
      <>
        {this.props.children}
        {this.state.errorInfo && this.state.open && (
          <Modal
            message={this.state.error.message}
            information={this.state.errorInfo.componentStack}
            onClose={() => this.setState({ open: false })}
          />
        )}
      </>
    );
  }
}

export default ErrorBoundary;
